
<section #title>

    <owl-carousel-o #items
        class="perspectives"
        [options]="perspectives"
        (changed)="translated($event)">
        <ng-template carouselSlide *ngFor="let item of content[language].perspectives.images">
            <div class="legend f-upper f-light d-flex f-right align-center justify-right" [innerHTML]="item.legend"></div>
            <div class="image">
                <img src="assets/content/{{ item.image }}" alt="{{ item.legend }}">
                <svg class="progress-ring" width="3.5rem" height="3.5rem">
                    <circle class="progress-ring__circle" stroke="white" stroke-width="0.6rem" fill="transparent" r="1.45rem" cx="1.75rem" cy="1.75rem"
                        stroke-dasharray="calc(1.45rem * 2 * 3.141592653589793)"
                        [attr.stroke-dashoffset]="'calc((1.45rem * 2 * 3.141592653589793) - ' + percent + ' / 100 * calc(1.45rem * 2 * 3.141592653589793))'" />
                </svg>
                <div class="progress-control" [class.stopped]="! controlIt" (click)="control()"></div>
            </div>
        </ng-template>
    </owl-carousel-o>

    <div class="perspectives-counter f-light f-center">
        {{ slidePosition }} / {{ content[language].perspectives.images.length }}
    </div>

</section>